import LoginButton from '@components/LoginButton'
import Text from '@components/V3/forms/Text'
import Phone from '@components/fields/Phone'
import useIsDarkMode from '@hooks/useIsDarkMode'
import useScreenSize from '@hooks/useScreenSize'

import HR from '../HR'
import {ReservationLabel} from '../Label'
import {useCreateReservationContext} from '../ReservationContext'

import LoggedIn from './LoggedIn'

export default function PersonalInformation() {
  const {userId, firstName, setFirstName, lastName, setLastName, email, setEmail, phone, setPhone} =
    useCreateReservationContext()
  const darkMode = useIsDarkMode()
  const screenSize = useScreenSize()

  if (userId) {
    return <LoggedIn />
  }

  return (
    <div className="space-y-2">
      <LoginButton
        invertColor={screenSize === 'mobile' && !darkMode}
        actionLocation="reservation"
      />
      <HR>o</HR>

      <ReservationLabel>Completa tus datos de contacto</ReservationLabel>
      <div className="grid grid-cols-2 space-x-2">
        <div className="">
          <Text
            disabled={!!userId}
            placeholder="Tu nombre"
            value={firstName}
            onChange={setFirstName}
          />
        </div>
        <div className="">
          <Text
            disabled={!!userId}
            placeholder="Tu apellido"
            value={lastName}
            onChange={setLastName}
          />
        </div>
      </div>
      <Text placeholder="Email" disabled={!!userId} value={email} onChange={setEmail} />
      <Phone placeholder="Teléfono" disabled={!!userId} value={phone} onChange={setPhone} />
      <div className="pt-5">
        <HR />
      </div>
    </div>
  )
}
